/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsługa formularzy
 * * OBIEKT FORM OBSLUGUJE JEDEN WSKKAZANY FORMULARZ!
 *
 * @export
 * @class Form
 * @extends {Inputs}
 */
import { Inputs } from "./Inputs.class";

export class Form extends Inputs{
	constructor(options) {
		super();
		var defaults = {
			selector: 'form',
			action: null,
			onSubmit: function () {
				this.defaultSubmitForm();
			}.bind(this),
			onError: function () {
				this.defaultErrorHandling();
			}.bind(this),
			method: null
		};
		this.settings = $.extend({}, defaults, options);
		this.form = null;
		this.inputs = null;
		this.selects = null;
		this.textareas = null;
		this.fieldsRequired = null;
		this.initForm();
	}
	// ****************************************************************************************************
	// Inicjalizacja
	// ****************************************************************************************************
	initForm() {
		var that = this;
		that.form = $(that.settings.selector + ':not(.simpleForm)');
		if (that.settings.action === null)
			that.settings.action = that.form.attr('action');
		if (that.settings.method === null)
			that.settings.method = (that.form.attr('method')) ? that.form.attr('method') : 'GET';
		if (that.form.length > 1) {
			console.warn('Form.class -> too many forms passed to object!');
		}
		else if (that.form.length == 0) {
			console.warn('Form.class -> NO forms passed to object! ->',that.settings.selector);
		}
		that.initSubmitBtn();
		that.initFields();
	}
	// ****************************************************************************************************
	// Odsieżenie formularza
	// ****************************************************************************************************
	refreshForm() {
		var that = this;
		that.initForm();
	}
	// ****************************************************************************************************
	// Inicjalizacja btn submit
	// ****************************************************************************************************
	initSubmitBtn() {
		var that = this;
		that.form.each(function (i, e) {
			var btn = $(e).find('button.submit');
			if ( btn.length > 0 ) {
				btn.off().on('click', function (event) {
					event.stopPropagation();
					event.preventDefault();
					if (that.validateForm()) {
						that.submitForm();
					} else {
						that.errorHandling();
						return false;
					}
				});
			} else {
				console.error('No submit button!');
			}
		});
	}
	// ****************************************************************************************************
	// Inicjalizacja inputów- każdy typ inputu musi tu być zarejestrowany
	// Dodane: search password email
	// ****************************************************************************************************
	initFields() {
		var that = this;
		that.inputs = $(that.settings.selector + ' input:not([type="hidden"])');
		that.inputs.each(function (i, e) {
			switch ($(e).attr('type')) {
				case 'email':
					that.initEmailInput($(e));
					break;
				case 'password':
					that.initPasswordInput($(e));
					break;
				case 'search':
					that.initSearchInput($(e));
					break;
				case 'text':
					that.initTextInput($(e));
					break;
				case 'checkbox':
					that.initCheckboxInput($(e));
					break;
				case 'file':
					that.initFileInput($(e));
					break;
			}
		});
		that.selects = $(that.settings.selector + ' select');
		that.selects.each(function (i, e) {
			that.initSelect($(e));
		});
		that.textareas = $(that.settings.selector + ' textarea');
		that.textareas.each(function (i, e) {
			that.initTextarea($(e));
		});
		that.fieldsRequired = $(that.settings.selector + ' input.required, ' + that.settings.selector + ' select.required, ' + that.settings.selector + ' textarea.required');
	}
	// ****************************************************************************************************
	// Domyslna obsługa zatwierdzenia formularza
	// ****************************************************************************************************
	defaultSubmitForm() {
		var that = this;
		that.form.submit(); // FixMe: czy nie trzeba tu sprawdzać, czy wszystkie pola nagłówkowe formularza są ustawione? (action, method, name...)
	}
	// ****************************************************************************************************
	// Zatwierdzenie formularza
	// ****************************************************************************************************
	submitForm() {
		var that = this;
		that.settings.onSubmit.call();
	}
	// ****************************************************************************************************
	// Domyslna obsługa błedu formularza
	// ****************************************************************************************************
	defaultErrorHandling() {
		var that = this;
		let firstInvalidElement = that.form.find('.required.input-required, .required.input-invalid, .required.input-failed, .reCaptchaDiv.captcha-required').first();

		if ( firstInvalidElement.length > 0 ) { // poprawka na TypeError: this.form.find(...).first(...).offset(...) is undefined
			$([document.documentElement, document.body]).animate({
				scrollTop: firstInvalidElement.offset().top - $('body').css('padding-top').replace(/([a-z])+/g, '') - 50
			}, 500);
		}
	}
	// ****************************************************************************************************
	// Obsługa błedu formularza
	// ****************************************************************************************************
	errorHandling() {
		var that = this;
		that.settings.onError.call();
	}
	// ****************************************************************************************************
	// Walidacja formularza
	// ****************************************************************************************************
	validateForm() {
		var that = this;
		var response = true;
		that.fieldsRequired.each(function (i, e) {
			$(e).trigger('validateInput');
			if ($(e).hasClass('input-invalid') || $(e).hasClass('input-required')) {
				response = false;
			}
		});
		response = that.validateCaptcha(response);
		return response;
	}
	// ****************************************************************************************************
	// Walidacja captchy google
	// ****************************************************************************************************
	validateCaptcha(res) {
		var that = this;
		var response = true;
		var captcha = $(that.settings.selector + ' .reCaptchaDiv');
		var captchaResponse = $(that.settings.selector + ' .g-recaptcha-response');
		if (captcha.length > 0) {
			if (captchaResponse.val() == "") {
				captcha.addClass('captcha-required');
				response = false;
			}
			else {
				captcha.removeClass('captcha-required');
				response = true;
			}
			if (!res)
				return res;
			else
				return response;
		}
		else
			return res;
	}
}